/* @flow strict */

import * as React from 'react';
import MailchimpSettings from '../../../../pages/Integrations/mailchimp/settings';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { GET, POST } from '/client/src/api';

type PropsType = {
  eventId: number | string
};

const EventMailchimpSettings = ({ eventId }: PropsType): React.Element<'div'> => {
  const context = React.useContext(DefaultContainerContext);

  const [isLoading, setLoading] = React.useState(false);
  const [isGlobalSync, setGlobalSync] = React.useState(false);
  const [listId, setListId] = React.useState(null);
  const [isSync, setSync] = React.useState(false);
  const [lists, setLists] = React.useState([]);

  React.useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      setLoading(true);
      const { result } = await GET(`/api/v1/1/mailchimp/${eventId}`);

      setLists(_.get(result, 'lists', []));
      setGlobalSync(_.get(result, 'enabled', false));
      setListId(_.get(result, 'listid', null));
      setSync(_.get(result, 'sync', false));
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const handleSettingsChange = async (isGlobalSync: boolean, listId: string, isSync: boolean) => {
    setLoading(true);
    try {
      await POST('/api/v1/1/mailchimp/eventsetting', {
        id: eventId,
        enabled: isGlobalSync,
        listid: listId,
        lists,
        sync: isSync
      });
      setLoading(false);
    } catch (e) {
      context.handleShowSystemDialog(true, {
        systemDialogType: 'error',
        systemDialogTitle: 'Oops!',
        systemDialogContent: 'Can\'t update'
      });
      setLoading(false);
      console.log(e);
    }
  };

  return (
    <div className='panel panel-default'>
      <div className="panel-heading panel-heading-color2">
        <div className="panel-title">
          <span>Mailchimp</span>
        </div>
      </div>
      <div className='IntegrationsMailchimp'>
        <MailchimpSettings
          isEvent
          isLoading={isLoading}
          globalsync={isGlobalSync}
          listid={listId}
          sync={isSync}
          lists={lists}
          onHandleSettingsChange={handleSettingsChange}
        />
      </div>
    </div>
  );
};

export default EventMailchimpSettings;
